import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/components/footer.scss";

const Footer = () => {
	return (
		<footer className="footer d-flex flex-column flex-md-row justify-content-between align-items-center">
			<NavLink exact to="/" activeClassName="nav-active">
				<img src="/logo-fim.png" alt="logo-FIM" />
			</NavLink>

			<NavLink
				className="a-footer d-flex justify-content-center"
				exact
				to="/APropos"
				activeClassName="nav-active">
				À propos
			</NavLink>

			<a
				href="https://www.themoviedb.org/movie"
				target="_blank"
				rel="noopener noreferrer"
				className="tmdb-link">
				<img src="/logo-tmdb.svg" alt="logo-tmdb" />
			</a>
		</footer>
	);
};

export default Footer;
